<template>
    <div>
        <ConfirmDialog :dialogId="confirmNewDataDialogId" @hidden="resetInterval" dialogTitle="New data published" :dialogMessage="newDataMessage">
            <template v-slot:modal-footer>
                <b-button size="sm" variant="primary" @click="closeModal()">
                    Ok
                </b-button>
            </template>
        </ConfirmDialog>
    </div>
</template>

<script>
import ConfirmDialog from "@/components/Shared/FormElement/Dialogs/ConfirmDialog"
import { fetchFormFieldData } from "@/api/api.js"
import { daysBetweenDates } from "@/api/utils.js"

export default {
    name: "PubDatesChecker",
    components: {
        ConfirmDialog,
    },
    data() {
        return {
            isDialogClosed: false,
            confirmNewDataDialogId: "new-published-data-modal-confirm",
            newDataMessage: "",
        }
    },
    async mounted() {
        this.versionIntervalId = setInterval(this.checkPubDates, 300000)
    },
    beforeDestroy() {
        clearInterval(this.versionIntervalId)
    },
    methods: {
        async checkPubDates() {
            try {
                const information = await fetchFormFieldData("Information")
                if (information.statusCode) {
                    this.toastMessage(information.errorMessage, false)
                } else {
                    let previousContentDate = this.$store.getters.getPublishedToDate
                    let previousAdDate = this.$store.getters.getMetadataAdToDate
                    await this.$store.dispatch("updateSSASMessage")
                    if (!previousContentDate || !previousAdDate) {
                        return
                    }
                    //check if any new date is available and if so trigger dialog with message which tabs have updated data available
                    let newItems = []
                    if (previousAdDate != null && daysBetweenDates(previousAdDate, this.$store.getters.getMetadataAdToDate) > 0) {
                        newItems.push("AD")
                    }
                    if (previousContentDate != null && daysBetweenDates(previousContentDate, this.$store.getters.getPublishedToDate) > 0) {
                        newItems.push("PROGRAM and CHANNEL")
                    }
                    if (newItems.length > 0 && !this.isDialogClosed) {
                        this.newDataMessage = "New data for " + newItems.join(", ") + " has been published that you can now run queries on."
                        // show modal
                        this.$bvModal.show(this.confirmNewDataDialogId)
                    }
                }
            } catch (error) {
                if (error.response?.status != 401) this.toastMessage("Problem fetching default dates from server. The service will not work correctly.", true)
                console.error(error)
            }
        },
        toastMessage(message, closeButton) {
            if (closeButton) {
                const h = this.$createElement

                const vNodesMsg = h("div", [
                    h("p", { class: ["mb-0"] }, "Problem fetching default dates from server. The service will not work correctly."),
                    h(
                        "b-button",
                        {
                            class: ["closebtn", "btn-sm"],
                            on: {
                                click: () => this.$bvToast.hide("toast"),
                            },
                        },
                        "Close"
                    ),
                ])

                this.$bvToast.toast([vNodesMsg], {
                    id: "toast",
                    title: "Error",
                    variant: "danger",
                    solid: true,
                    noCloseButton: true,
                    noAutoHide: true,
                })
            } else {
                this.$bvToast.toast(message, {
                    title: "Warning",
                    variant: "warning",
                    solid: true,
                    noCloseButton: false,
                })
            }
        },
        closeModal() {
            this.isDialogClosed = true
            this.$bvModal.hide(this.confirmNewDataDialogId)
        },
        resetInterval() {
            this.isDialogClosed = true
            setTimeout(() => (this.isDialogClosed = false), 300000)
        },
    },
}
</script>
